import { useParams } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { Meta, ErrorMessage } from "@/shared/components";
import { useTranslationEditQuery } from "@/admin/entities/translations";
import { TranslationEditor } from "@/admin/features/translations";

export function TranslationEditorPage() {
  const { id, languageCode } = useParams<{
    id: string;
    languageCode: string;
  }>();
  const { data, loading, error } = useTranslationEditQuery(id ?? null);

  if (error) return <ErrorMessage error={error} />;
  if (loading || !data?.translation || !languageCode) return <LinearProgress />;

  return (
    <>
      <Meta title="Редактор перевода" />
      <TranslationEditor
        translation={data.translation}
        languageCode={languageCode}
      />
    </>
  );
}
